

    <svg:svg class="svg-designer graph-bg workflow-designer"
             version="1.1"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             style="display: block; margin: auto;" [attr.width]="computedWidth"
             [style.background-size.px]="zoom * 100"
             (mousedown)="onMouseDown($event)"
             [attr.height]="computedHeight" [attr.viewBox]="viewBox">

      <style>

        text {
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          cursor: default;
        }

        .graph-vertex {
          opacity: 0.85;
          transition: 500ms;
          transition-timing-function: ease-in-out;
          transition-property: opacity;
        }

        .graph-vertex:hover {
          opacity: 1;
        }

        .graph-vertex .io-type {
          opacity: 0;
          transition: 500ms;
          transition-timing-function: ease-in-out;
          transition-property: opacity;
          fill: #FC644B;
          visibility: hidden;
        }

        .graph-vertex:hover .io-type {
          opacity: 1;
          visibility: visible;
        }

        .graph-vertex .activated-io-type {
          opacity: 1;
          visibility: visible;
          fill: #50AE01;
        }

        .anchor-point {
          cursor: crosshair;
        }

        .highlighted-point {
          fill: #50AE01;
          stroke: #50AE01;
        }
      </style>

      <svg:defs>
        <marker id="ConnectionHead"
                viewBox="0 0 20 20"
                refX="50" refY="10"
                markerWidth="10"
                markerHeight="10"
                fill="#555"
                orient="auto">
          <path d="M 0 0 L 20 10 L 0 20 z"/>
        </marker>
        <marker id="NewConnectionHead"
                viewBox="0 0 20 20"
                refX="50" refY="10"
                markerWidth="10"
                markerHeight="10"
                fill="#50AE01"
                orient="auto">
          <path d="M 0 0 L 20 10 L 0 20 z"/>
        </marker>
        <filter x="0" y="0" width="1" height="1" id="edgeValue">
          <feFlood flood-color="black"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </svg:defs>

      <svg:g wf-graph-vertex *ngFor="let vertex of vertexList" [vertex]="vertex" [zoom]="zoom"
             [editable]="editable"/>

      <svg:g wf-graph-edge *ngFor="let edge of edgeList" [edge]="edge"/>

      <svg:g *ngIf="editable" wf-graph-draw-edge [zoom]="zoom"/>

      <svg:rect *ngIf="selectionPlaceholder && selectionPlaceholder.active"
                [attr.x]="selectionPlaceholder.x"
                [attr.y]="selectionPlaceholder.y"
                [attr.width]="selectionPlaceholder.width"
                [attr.height]="selectionPlaceholder.height"
                stroke-dasharray="5,5"
                stroke-width="2"
                stroke="#FF00FF"
                fill="#FF00FF22"/>

    </svg:svg>

  


// WEBPACK FOOTER //
// ./src/library/graph/workflow-graph.component.ts.WorkflowGraphComponent.html